import React, { useState, useEffect, useContext } from 'react'
import OriginsManagementOrders from './OriginsManagementOrders'
import OriginsDirectOrders from './OriginsDirectOrders'
import { AuthenticationContext } from '../../../Auth/authentication.context'
import { useBranding } from '../../../contexts/BrandingContext'

export default function PharmacyOrders() {
  const { module } = useContext(AuthenticationContext)
  const { isGroupMode } = useBranding()
  const [userModule, setUSerModule] = useState('')

  useEffect(() => {
    if (module) {
      setUSerModule(module)
    }
  }, [module])

  if (isGroupMode) {
    return <OriginsManagementOrders />
  }
  if (
    userModule === 'Origins Direct' ||
    userModule === 'Origins Direct Instant'
  ) {
    return <OriginsDirectOrders />
  }
  if (module === 'Origins Management') {
    return <OriginsManagementOrders />
  }
  return <div>User has no System or unrecognized System.</div>
}
